export default "__VITE_ASSET__xvORvaHf__"